/*
 * Weekplan Messages
 *
 * This contains all the text for the Weekplan component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  releaseWeekSuccess: {
    id: 'app.containers.ReleaseWeekMenuItem.releaseWeekSuccess',
    defaultMessage: 'Successfully released week',
  },
  releaseWeekFailure: {
    id: 'app.containers.ReleaseWeekMenuItem.releaseWeekFailure',
    defaultMessage: 'Error. Releasing week failed.',
  },
  releaseWeek: {
    id: 'app.containers.ReleaseWeekMenuItem.releaseWeek',
    defaultMessage: 'Release week',
  },
});
